/**
 * 文本处理工具函数
 */

/**
 * 将文本中的 \n 转换为 HTML 换行标签
 * @param text 需要处理的文本
 * @returns 处理后的文本，\n 被替换为 <br/>
 */
export const formatTextWithLineBreaks = (text: string): string => {
  if (!text) return '';
  return text.replace(/\n/g, '<br/>');
};

/**
 * 将文本中的 \n 转换为实际换行符（用于 React 组件中的 whitespace: pre-line 样式）
 * @param text 需要处理的文本
 * @returns 处理后的文本，保持原有的换行符
 */
export const formatTextWithNewlines = (text: string): string => {
  if (!text) return '';
  return text.replace(/\n/g, '\n');
};